import { useBreakpoint } from './useBreakpoint';
export function useIsMobile() {
    const breakpoint = useBreakpoint();
    return breakpoint === 'base' || breakpoint === 'xs' || breakpoint === 'sm';
}
